<script>
export default {
  name: 'OptionGroup',
  props: []
}
</script>

<template>
  <div
    class="OptionGroup tw-h-full tw-w-full tw-border-t tw-border-[#445f74]/30 tw-py-2"
  >
    <slot />
  </div>
</template>
